/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';

@Component({
  selector: 'app-theme-options-legend',
  templateUrl: './theme-options-legend.component.html',
  styleUrls: ['./theme-options-legend.component.css']
})
export class ThemeOptionsLegendComponent {

  @Input() themeOptions: ThemeOptionsClass;
  
  color = ItemColor('themes');

  editorIndex: number;
  editorIndexMax: number;

  constructor() {
    this.editorIndex = 0;
    this.editorIndexMax = 1;
  }

  receiveNext(isNext: boolean) {
    this.editorIndex = this.editorIndex + (isNext ? 1 : -1);
    if(this.editorIndex < 0) this.editorIndex = this.editorIndexMax;
    if(this.editorIndex > this.editorIndexMax) this.editorIndex = 0;
  } 

}
